module.exports = __webpack_public_path__ + "static/media/17import-37.8c0f2e76.xlsx";